import styled, { css } from "styled-components";
import { buttonBorderRadius, color, units, variant, visuallyHidden } from "@m/alchemy-theme";
import { rgba } from "polished";
import { ArrowIcon, MenuButton } from "../menu-button/MenuButton.styled";
import { Button } from "../button/Button.styled";
const variants = variant("priority", {
    primary: css `
    ${Button}:first-child {
      margin-right: 1px;
    }
  `,
    secondary: css `
    ${Button}:first-child {
      border-right: none;
    }
  `,
    success: css `
    ${Button}:first-child {
      position: relative;
    }
    ${Button}:first-child:after {
      position: absolute;
      right: -1px;
      content: "";
      display: block;
      width: 1px;
      top: 0;
      bottom: 0;
      background-color: ${color("inverse")};
      z-index: 1;
    }
    > *:last-child {
      left: -1px;
    }
  `,
    tertiary: css `
    ${Button}:first-child {
      position: relative;
    }
    ${Button}:first-child:after {
      position: absolute;
      top: ${units(1.25)};
      right: -2px;
      content: "";
      display: block;
      width: 1px;
      height: ${units(2)};
      background-color: ${color("line")};
      z-index: 1;
    }

    &:hover,
    &:focus {
      ${Button}:first-child:after {
        display: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? "none" : "block")};
      }
    }
    ${Button} {
      background-color: transparent;
      color: ${({ activeColorScheme }) => (activeColorScheme === "alchemyBrand" ? color("inverse") : color("base"))};

      ${(props) => css `
        &:not([disabled]) {
          &:hover,
          &:focus {
            background-color: ${props.activeColorScheme === "alchemyBrand"
        ? rgba(color("highlight")(props), 0.35)
        : color("hint")};
            border-color: ${props.activeColorScheme === "alchemyBrand"
        ? rgba(color("inverse")(props), 0.2)
        : color("highlight")};
          }
        }
      `}
    }
  `,
    global: css `
    ${Button}:first-child {
      position: relative;
    }
    ${Button}:first-child:after {
      position: absolute;
      right: -1px;
      content: "";
      display: block;
      width: 1px;
      top: 0;
      bottom: 0;
      background-color: ${color("highlight", {
        palette: "interactiveConstructive"
    })};
      z-index: 1;
    }
    > *:last-child {
      left: -1px;
    }
  `
});
export const SplitButton = styled.div `
  display: ${({ display }) => (display === "block" ? "block" : "inline-block")};
  margin: ${units(0.5)};
`;
export const SplitButtonContents = styled.div `
  display: flex;
  justify-content: center;
  align-items: stretch;

  ${Button} {
    padding-left: ${units(1.5)};
    padding-right: ${units(1.25)};
    border-radius: ${buttonBorderRadius()} 0 0 ${buttonBorderRadius()};
  }
  ${MenuButton} {
    width: ${units(4.5)};
    left: 0;
    padding: 0;
    border-radius: 0 ${buttonBorderRadius()} ${buttonBorderRadius()} 0;

    ${ArrowIcon} {
      right: ${units(1.25)};
      width: ${units(2.25)};
      height: ${units(2.25)};
    }
  }
  ${variants};
`;
export const SplitButtonHiddenContent = styled.span `
  ${visuallyHidden()}
`;
